<div class="principal">
	<img src="../../assets/images/welcome-parameters.svg" alt="search" />
	<h2>Parameters</h2>
	<p>Aún no has ingresado los parámetros de búsqueda</p>
</div>
